// ####################################################

// import React from "react";
// import { Box, Typography } from "@mui/material";
// import MDButton from "components/MDButton";
// import PropTypes from "prop-types";
// import { useNavigate } from "react-router-dom";
// import Card from "@mui/material/Card";

// function ChartNotEntitled({ featureName, planRequired, style = {} }) {
//   const navigate = useNavigate();

//   return (
//     <Box
//       sx={{
//         position: "absolute",
//         top: 22.5,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         backdropFilter: "blur(6px)",

//         // Gradient top → frosted bottom
//         background: `
//           linear-gradient(
//             to bottom,
//             rgba(255,255,255,1) 0%,
//             rgba(255,255,255,0.8) 2%,
//             rgba(164,162,162,0.55) 60%
//           )
//         `,

//         borderRadius: "12px",
//         zIndex: 20,
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         px: 3,
//         py: 2,
//         textAlign: "center",
//         ...style,
//       }}
//     >
//       {/* INNER CARD */}
//       <Card
//         elevation={4}
//         sx={{
//           p: 4,
//           maxWidth: 460,
//           borderRadius: "16px",
//           textAlign: "center",
//           backgroundColor: "rgba(255,255,255,0.85)",
//           backdropFilter: "blur(2px)",
//         }}
//       >
//         <Typography variant="h6" sx={{ mb: 1, fontWeight: 700 }}>
//           {featureName} is not available on your plan
//         </Typography>

//         <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//           Upgrade to <strong>{planRequired}</strong> to unlock this feature.
//         </Typography>

//         <MDButton
//           variant="contained"
//           color="accent"
//           size="medium"
//           onClick={() => navigate("/profile")}
//           sx={{ px: 3, py: 1.2, fontWeight: 600, width: "auto", minWidth: "180px", alignSelf: "center" }}
//         >
//           Upgrade Plan
//         </MDButton>
//       </Card>
//     </Box>
//   );
// }

// ChartNotEntitled.propTypes = {
//   featureName: PropTypes.string.isRequired,
//   planRequired: PropTypes.string.isRequired,
//   style: PropTypes.object,
// };

// export default ChartNotEntitled;



// ################################################################
import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import MDButton from "components/MDButton";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Backdrop from "@mui/material/Backdrop";
import Slide from "@mui/material/Slide";
import Plan from "layouts/profile/components/Subscription/plan";

function ChartNotEntitled({
  featureName,
  planRequired,
  style = {},
}) {
  const [openPlan, setOpenPlan] = useState(false);

  const handleUpgradeClick = () => {
    setOpenPlan(true);
  };

  const handleClosePlan = () => {
    setOpenPlan(false);
  };

  return (
    <>
      {/* Frosted overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 22.5,
          left: 0,
          right: 0,
          bottom: 0,
          backdropFilter: "blur(12px)",
          background: `
            linear-gradient(
              to bottom,
              rgba(255,255,255,1) 0%,
              rgba(255,255,255,0.8) 2%,
              rgba(164,162,162,0.55) 60%
            )
          `,
          borderRadius: "12px",
          zIndex: 20,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          px: 3,
          py: 2,
          textAlign: "center",
          ...style,
        }}
      >
        <Card
          elevation={4}
          sx={{
            py: 2,
            px: 4,
            maxWidth: 460,
            borderRadius: "16px",
            textAlign: "center",
            backgroundColor: "rgba(255,255,255,0.85)",
            backdropFilter: "blur(2px)",
          }}
        >
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 700 }}>
            {featureName} is not available on your plan
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Upgrade to <strong>{planRequired}</strong> to unlock this feature.
          </Typography>

          <MDButton
            variant="contained"
            color="accent"
            size="medium"
            onClick={handleUpgradeClick}
            sx={{ px: 3, py: 1.2, fontWeight: 600, width: "auto", minWidth: "180px", alignSelf: "center" }}
          >
            Upgrade Plan
          </MDButton>
        </Card>
      </Box>

      {/* PLAN MODAL */}
      <Backdrop
        open={openPlan}
        sx={{
          zIndex: (t) => t.zIndex.modal + 30,
          backgroundColor: "rgba(0,0,0,0.7)",
        }}
      >
        <Slide direction="up" in={openPlan} mountOnEnter unmountOnExit>
          <Card
            sx={{
              width: "95%",
              maxWidth: "90vw",
              maxHeight: "90vh",
              overflowY: "auto",
              p: 3,
              backgroundColor: "white",
              borderRadius: "16px",
              position: "relative",
              boxShadow: "0 6px 18px rgba(0,0,0,0.2)",
            }}
          >
            <MDButton
              variant="text"
              onClick={handleClosePlan}
              sx={{
                position: "absolute",
                top: 10,
                right: 10,
                fontWeight: "bold",
                textTransform: "none",
                color: "#444 !important",
              }}
            >
              Close
            </MDButton>

            {/* Pass required props */}
            <Plan
              onClose={handleClosePlan}
            />
          </Card>
        </Slide>
      </Backdrop>
    </>
  );
}

ChartNotEntitled.propTypes = {
  featureName: PropTypes.string.isRequired,
  planRequired: PropTypes.string.isRequired,
  style: PropTypes.object,
};

export default ChartNotEntitled;
